<template>
  <div id="user-detail">
    <ol class="breadcrumb pull-right">
      <li><router-link :to="{path: '/'}">Home</router-link></li>
      <li>User Management</li>
      <li class="active">User Detail</li>
    </ol>
    <!-- end breadcrumb -->
    <!-- begin page-header -->
    <h1 class="page-header">Informasi Detail User</h1>
    <!-- end page-header -->
    <div class="row">
      <div class="col-md-12">
        <!-- begin panel -->
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">User Info</h4>
          </div>
          <div class="panel-body">
            <div class="media">
              <div class="media-body">
                <div style="background:white; display:flex; align-items:center;">
                  <div style="margin:10px;">
                    <img :src="userData.picture" alt="profile_picture" class="media-object">
                  </div>
             <div style="width: 150px; border:1px solid green; padding:15px; margin:10px; text-align:center; border-radius:5px;">
              Jumlah Tiket
              <h3 style="line-height:0;">{{ users_ticket }}</h3>
             </div>
             <div style="width: 150px; border:1px solid green; padding:15px; margin:10px; text-align:center; border-radius:5px;">
              Jumlah Kuota Konsul
              <h3 style="line-height:0;">{{ users_consul_session }}</h3>
             </div>
            </div>
                <table class="table">
                  <tbody>
                    <tr>
                      <td style="width: 15%"><strong>Nama</strong></td>
                      <td>{{userData.name}}</td>
                    </tr>
                    <tr>
                      <td><strong>No. Siswa</strong></td>
                      <td>{{userData.student_number}}</td>
                    </tr>
                    <tr>
                      <td><strong>Email</strong></td>
                      <td>{{userData.email}}
                        <button @click="showEditEmail()" class="btn btn-success" style="font-size:11px; padding: 5px 7px 5px 7px; margin-left: 15px;"><i class="fa fa-pencil"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>No. Telpon</strong></td>
                      <td>{{userData.phone_number}}</td>
                    </tr>
                    <tr>
                      <td><strong>Provinsi</strong></td>
                      <td>{{userData.province}}</td>
                    </tr>
                    <tr>
                      <td><strong>Kota/Kabupaten</strong></td>
                      <td>{{userData.city}}</td>
                    </tr>
                    <tr>
                      <td><strong>Jenis Sekolah</strong></td>
                      <td>{{userData.school_type}}</td>
                    </tr>
                    <tr>
                      <td><strong>Sekolah</strong></td>
                      <td>{{userData.school ? userData.school : ''}}
                        <button @click="showEditForm()" class="btn btn-success" style="font-size:11px; padding: 5px 7px 5px 7px; margin-left: 15px;"><i class="fa fa-pencil"></i></button>
                      </td>
                    </tr>
                    <tr>
                      <td><strong>Kelas</strong></td>
                      <td>
                        <select v-model="grade">
                          <option value="0">0</option>
                          <option v-bind:key="n" v-for="n in 12" :value="n">{{n}}</option>
                        </select>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Scope</h4>
          </div>
          <div class="panel-body">
            <div class="row">
              <div class="col-md-3">
                <b>Nama Fitur</b>
              </div>
              <div class="col-md-4">
                <b>Tanggal Expired</b>
              </div>
            </div>
            <div class="row" v-for="(item, index) in scopeModel" :key="index" style="margin-bottom:10px;">
              <div class="col-md-3">
                {{item.display_name}}
              </div>
              <div class="col-md-4" style="display:flex;flex-flow:row;">
                <!-- <transition name="fade">
                        <div class="input-group"> -->
                  <date-picker value-type="timestamp" v-model="scopeModel[index].expired_at" @change="updateTanggalScope(item, index)" valueType="format"></date-picker>
                  <button style="margin-left:10px;"
                    class="btn btn-danger btn-xl"
                    @click="deleteScope(item,index)" 
                  >
                    <i class="fa fa-trash"></i>
                  </button>
                          <!-- <input
                            :id="'expiredScope'"
                            type="text"
                            v-model="scopeModel[index].expired_at"
                            class="form-control datepicker"
                            name="expired_scope"
                            readonly
                            style="color: black !important;background: white !important;"
                          />
                          <span class="input-group-btn">
                            <button class="btn btn-success" type="button">
                              <i class="fa fa-calendar"></i>
                            </button>
                          </span>
                        </div>
                      </transition>
                      <button style="margin-left:10px;"
                    class="btn btn-danger btn-xl"
                    
                  >
                    <i class="fa fa-trash"></i>
                  </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <div class="panel panel-inverse">
          <div class="panel-heading">
            <h4 class="panel-title">Riwayat Pengerjaan Tryout (Beragenda)</h4>
          </div>
          <div class="panel-body">
            <div class="tryout-section" v-for="(membership, key) in memberships" v-bind:key="key" style="margin-bottom: 50px">
              <h4>{{membership.name}}</h4>
              <p><strong>({{displayTimestamp(membership.opened_at)}} - {{displayTimestamp(membership.closed_at)}})</strong></p>
              <table class="table">
                <thead>
                  <tr>
                    <th style="width: 30%">Name</th>
                    <th>Status</th>
                    <th>Pengerjaan (Menit)</th>
                    <th>Jml. Soal</th>
                    <th>Benar</th>
                    <th>Salah</th>
                    <th>Kosong</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tr v-for="(tryout, key) in membership.tryouts" v-bind:key="key">
                  <td>{{tryout.name}}</td>
                  <td>
                    <div class="tryout-state" v-if="tryout.state === 'JOINED'">
                      <button class="btn btn-default btn-xs">BERGABUNG</button>
                    </div>
                    <div class="tryout-state text-center" v-if="tryout.state === 'STARTED'">&nbsp;
                      <button class="btn btn-warning btn-xs mb-1">MENGERJAKAN</button><br/>
                      <span>({{displayTimestamp(tryout.started_at)}})</span>
                    </div>
                    <div class="tryout-state text-center" v-if="tryout.state === 'FINISHED'">&nbsp;
                      <button class="btn btn-warning btn-xs mb-1">MENGUMPULKAN</button><br/>
                      <span>({{displayTimestamp(tryout.completed_at)}})</span>
                    </div>
                    <div class="tryout-state" v-if="tryout.state === 'GRADED'">
                      <button class="btn btn-success btn-xs">DINILAI</button>
                    </div>
                  </td>
                  <td class="text-center">{{tryout.completion_time ? Math.ceil(tryout.completion_time / 60) : '-'}}</td>
                  <td class="text-center">{{getItemCount(tryout)}}</td>
                  <td class="text-center">{{tryout.correct}}</td>
                  <td class="text-center">{{tryout.wrong}}</td>
                  <td class="text-center">{{tryout.empty}}</td>
                  <td class="text-center d-flex">
                    <button class="btn btn-warning btn-xs mr-1" :disabled="tryout.state === 'JOINED'" @click="resetState(tryout.bundle_code, $store.state.usman.email)">RESET</button>
                    <button class="btn btn-success btn-xs" :disabled="tryout.state === 'JOINED'" @click="gradingState(tryout.bundle_code, $store.state.usman.email)">GRADING</button>
                    <!-- <button class="btn btn-warning btn-xs" :disabled="tryout.state === 'JOINED'" @click="resetState(tryout, $store.state.usman.email)">RESET</button> -->
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <app-spinner v-if="isLoading"></app-spinner>
    <div class="modal fade bs-example-modal-sm" id="modalEditEmail" tabindex="-1" role="dialog" aria-labelledby="FilterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document" style="max-width: 400px !important; ">
        <div class="modal-content">
          <div class="modal-header" style="display:flex; justify-content:space-between;">
            <h4 id="exampleModalLongTitle">Ubah Email User</h4>
            <button type="button" class="close" data-dismiss="modal" style="position:absolute;right:15px;" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:0;">
            <div class="list-group">
              <form action="submit">
                <label for="basic-url">Email Saat Ini</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <b>{{ detailUser.email }}</b>
                </div>

                <label for="basic-url">Masukkan email baru</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <input @focus="newEmail = ''" type="text" class="form-control" placeholder="Masukkan email baru" v-model="newEmail" />
                </div>
              </form>
              <div v-if="listEmailSigned != null && listEmailSigned.length > 0">
                <div v-for="(item, index) in listEmailSigned" :key="index" style="padding-bottom: 7px; padding-top: 7px; border-bottom: 1px solid;">
                  <p>Nama: {{item.name}}</p>
                  <p>No Handphone: {{item.phone_number}}</p>
                  <p>Tanggal Lahir: {{item.birth_date}}</p>
                </div>
              </div>
              <div v-if="listEmailSigned && listEmailSigned.length === 0" style="text-align:center;">
                <p>Email baru belum terdaftar dalam sistem</p>
              </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-info" @click="checkEmail()">
                Cek Email Baru
              </button>
              <button v-if="listEmailSigned && listEmailSigned.length === 0" type="button" class="btn btn-success" @click="updateEmail()">
                Update Email
              </button>
              <button v-if="listEmailSigned && listEmailSigned.length === 1" type="button" class="btn btn-success" @click="updateEmail()">
                Swap Email
              </button>
            </div>
          </div>
        </div>
      </div>

    <div class="modal fade bs-example-modal-sm" id="modalEditSekolah" tabindex="-1" role="dialog" aria-labelledby="FilterModal" aria-hidden="true">
    <div class="modal-dialog modal-sm" role="document" style="max-width: 400px !important; ">
        <div class="modal-content">
          <div class="modal-header" style="display:flex; justify-content:space-between;">
            <h4 id="exampleModalLongTitle">Ubah Data Sekolah User</h4>
            <button type="button" class="close" data-dismiss="modal" style="position:absolute;right:15px;" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div class="modal-body" style="margin:0;">
            <div class="list-group">
              <form action="submit">
                <label for="basic-url">Jenis Sekolah</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="formUpdateSekolah.jenisSekolah">
                    <option value="FORMAL" >Formal</option>
                    <option value="INFORMAL">Informal</option>
                  </select>
                </div>

                <label for="basic-url">Provinsi</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="formUpdateSekolah.provinsi">
                    <option :value="province.value" v-for="(province, i) in provinceList" :key="i">{{ province.text }}</option>
                    <!-- <option value="INFORMAL">Informal</option> -->
                  </select>
                </div>

                <label for="basic-url">Kota/Kabupaten</label>
                <div class="input-group" style="margin-bottom: 20px;">
                  <select class="form-control" v-model="formUpdateSekolah.kota">
                    <option :value="city.value" v-for="(city, i) in cityList" :key="i">{{ city.text }}</option>
                  </select>
                </div>

                <label for="basic-url">Nama Sekolah</label>
                <div class="input-group" style="margin-bottom: 20px;display:flex;">
                  <input class="form-control" v-model="formUpdateSekolah.namaSekolah" @keypress.enter.prevent="commitSearch()" :placeholder="'nama sekolah'"/>
                  <button type="button" class="btn btn-success" style="padding:5px 15px 5px 15px; font-size: 11px;" @click="commitSearch()">Cari</button>
                  <!-- <select class="form-control" v-model="formUpdateSekolah.namaSekolah">
                    <option :value="sekolah.text" v-for="(sekolah, i) in schoolList" :key="i">{{ sekolah.text }}</option>
                  </select> -->
                </div>
                  <ul class="list-group" style="max-height: 250px; overflow:auto;" v-if="formUpdateSekolah.namaSekolah !== '' && showSuggestion">
                    <li @click="selectingSchool(suggestion)" v-bind:key="index" v-for="(suggestion,index) in querySchool" class="list-group-item" >
                      <span>{{ suggestion.text }}</span>
                    </li>
                    <li class="list-group-item" v-if="formUpdateSekolah.namaSekolah !== '' && showSuggestion && querySchool.length === 0">
                      Data tidak ditemukan, perhatikan huruf besar kecil dan spasi!
                    </li>
                  </ul>
                <div style="margin-top:15px;">
                  <button type="button" class="btn btn-success" style="padding:5px; font-size: 11px;" @click="updateDataSekolah()">Update Data Siswa</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axios from 'axios'
import moment from 'moment'
import AccountService from '@/services/auth.js'
import UsmanService from '@/services/usman.js'
import Spinner from '@/components/plugins/Spinner'
import TryoutService from "@/services/tryout.js";
import Modal from '@/components/plugins/Modal'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: 'user-detail',
  components: {
    'app-spinner': Spinner,
    'app-modal': Modal,
    DatePicker
  },
  data: function () {
    return {
      memberships: [],
      emailSIP: null,
      nomorIndukNF: null,
      isLoading: false,
      provinceList: [],
      cityList: [],
      showSuggestion: false,
      users_consul_session: 0,
      users_ticket: 0,
      schoolList: [],
      query: '',
      scopeModel: [],
      detailUser: false,
      newEmail: null,
      listEmailSigned: null,
      formUpdateSekolah: {
        jenisSekolah: null,
        provinsi: null,
        kota: null,
        namaSekolah: null,
        npsn: null,
        akreditasi: null,
      },
      userData: {
        picture:null,
        name:null,
        school: null,
        email: null,
        phone_number: null,
        student_number: null
      },
      querySchool: [],
      scopeList: null,
    }
  },
  computed: {
    isActive: function () {
      var now = new moment()
      var expiredAt = new moment(this.userData.expired_at, "YYYY-MM-DD")
      var diff = expiredAt.valueOf() - now.valueOf()

      return diff > 0
    },
    grade: {
      get: function() {
        return this.userData.grade
      },
      set: function(newVal) {
        var context = this
        var userId = this.userData.user_id
        UsmanService.updateUserGrade({user_id: userId, grade: newVal}, function(response) {
          if (response.success) {
            context.$store.commit('usman_set_grade', newVal)
            window.alert('Berhasil mengubah data kelas siswa')
          } else {
            window.alert('Gagal mengubah data kelas siswa')
          }
        })
      }
    }
  },
  watch: {
    'formUpdateSekolah.provinsi'(to, from){
      this.cityList = []
      this.getCity(to)
    },
    'formUpdateSekolah.kota'(to, from){
      this.schoolList = []
      this.getSchoolData(to)
    },
    newEmail(to, from){
      if(to === '') this.listEmailSigned = null
    }
  },
  methods: {
    loadDetailData: function () {
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/tryout-service/membership'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {
        params: {
          email: this.userData.email
        }
      })
      .then(function (response) {
        context.memberships = response.data
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function () {
        context.isLoading = false
      })
    },
    loadDetailUser: function () {
      var context = this
      var token = this.$ls.get('token');
      let uid = JSON.parse(sessionStorage.usman_init)
      var url = process.env.API_BASE_URL + '/account/usman/user/' + uid.user_id

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {})
      .then(function (response) {
        context.scopeModel = []
        response.data.scopes.forEach(element => {
          console.log(element)
          if(element.name !== 'app_basic') context.scopeModel.push(element)
        });
        // context.scopeModel = response.data.scopes
        context.scopeModel.sort((a, b) => parseFloat(a.id) - parseFloat(b.id));
        context.detailUser = response.data
        sessionStorage.setItem('usman_init', JSON.stringify(response.data))
        context.userData = JSON.parse(sessionStorage.usman_init)
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function () {
        context.isLoading = false

      })
    },
    loadTicketUser: function () {
      var context = this
      var token = this.$ls.get('token');
      let uid = JSON.parse(sessionStorage.usman_init)
      var url = process.env.API_BASE_URL + '/sales/check-user-ticket?user_id=' + uid.user_id

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {})
      .then(function (response) {
        context.users_ticket = response.data.ticket_value
        console.log(response)
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function () {
        context.isLoading = false

      })
    },
    loadQuotaConsulUser: function () {
      var context = this
      var token = this.$ls.get('token');
      let uid = JSON.parse(sessionStorage.usman_init)
      var url = process.env.API_BASE_URL + '/konsul/v2/student-credit/' + uid.user_id

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      http.get(url, {})
      .then(function (response) {
        context.users_consul_session = response.data.consultation_credit
        console.log(response)
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function () {
        context.isLoading = false

      })
    },
    displayTimestamp: function (timeInMilis) {
      if (!timeInMilis) return '-'
      return moment(timeInMilis).format('D MMM YYYY HH:mm')
    },
    getItemCount: function (tryout) {
      var total = 0;
      tryout.subtests.forEach(function (subtest) {
        total += subtest.item_count
      })

      return total
    },
    activateUser: function () {
      var userId = this.userData.user_id
      var cleanString = this.nomorIndukNF.replace(/-/g, '')
      var formattedNoInduk = this.nomorIndukNF

      if (cleanString.length === 10) {
        formattedNoInduk = cleanString.substring(0,3) +
          '-' + cleanString.substring(3,5) +
          '-' + cleanString.substring(5)
      }

      this.isLoading = true
      var context = this
      AccountService.userActivation(userId, this.emailSIP, formattedNoInduk, function (response) {
        if (response.success) {
          var userData = response.data
          context.$store.commit('usman_init', userData)
          context.$store.commit('error_dismiss')
        } else {
          context.$store.commit('error_show', 'Gagal melakukan aktivasi user')
        }

        context.isLoading = false
      })
    },
    resetState: function (bundle_code, email) {
      if(confirm("apakah anda yakin mengembalikan status pengerjaan try out ini menjadi Bergabung?")){
        var body = {
          bundle_code: bundle_code,
          email: email
        }
        // console.log(bundle_code)
        var context = this;
        TryoutService.resetStateTryout(body, function(result) {
          if (result.success) {
            context.loadDetailData()
            alert('Reset Sukses!')
          }
        })
      }
    },
    gradingState: function (bundle_code, email) {
      if(confirm("apakah anda yakin akan mengubah status try out ini menjadi Dinilai?")){
        var body = {
          bundle_code: bundle_code,
          email: email
        }
        // console.log(bundle_code)
        var context = this;
        TryoutService.gradingStateTryout(body, function(result) {
          if (result.success) {
            context.loadDetailData()
            alert('Grading Sukses!')
          }
        })
      }
    },
    showEditForm(){
      $('#modalEditSekolah').modal('show')
      this.getProvince()
      this.formUpdateSekolah = {
        jenisSekolah: this.userData.school_type,
        provinsi: this.userData.province,
        kota: this.userData.city,
        namaSekolah: this.userData.school,
        npsn: this.userData.school_npsn,
        akreditasi: this.userData.school_acreditation
      }
    },
    showEditEmail(){
      this.listEmailSigned = null

      $('#modalEditEmail').modal('show')
      
    },
    getProvince: function () {
      var queryStr = "q=*:*&";
      // if (this.params.search !== null) queryStr = "q=" + this.params.search + "&";
      // if(this.params.search == '') this.params.page = 0
      axios(
        "https://api.nfjuara.id/search/nfj_districts/select?" +
          queryStr +
          "fl=province_name_t%20province_code_i&rows=100&group=true&group.field=province_code_i",
        {
          auth: {
            username: "webapp",
            password: "8B^eduHKUu",
          },
        }
      ).then((response) => {
        var list = response.data.grouped.province_code_i.groups;
        list.forEach((element) => {
          this.provinceList.push({
            text: element.doclist.docs[0].province_name_t,
            value: element.doclist.docs[0].province_name_t,
          });
        });
      });
    },
    getCity: function (v) {
      // var queryStr = "q=*:*&";
      // if (this.params.search !== null)
      var queryStr = "q=province_name_t%3A%22" + encodeURIComponent(v) + "%22&";
      // if(this.params.search == '') this.params.page = 0
      axios(
        "https://api.nfjuara.id//search/nfj_districts/select?" +
          queryStr +
          "fl=city_name_t,city_code_i&rows=1000&start=0",
        // &fq=province_name_t:" +
        // encodeURIComponent(v),
        {
          auth: {
            username: "webapp",
            password: "8B^eduHKUu",
          },
        }
      ).then((response) => {
        var list = response.data.response.docs;
        list.forEach((element) => {
          this.cityList.push({
            text: element.city_name_t,
            value: element.city_name_t,
          });
        });
        // console.log(this.cityList)
      });
    },
    getSchoolData(v) {
      var queryStr = 'q=city_name_s:"' + v + '"&';
      var jenjang = "";
      if (this.userData.grade < 7) jenjang = "SD";
      else if (this.userData.grade < 10) jenjang = "SMP";
      else jenjang = "SMA";
      // if (this.params.search !== '') queryStr = 'q=' + this.params.search + '&'
      // if(this.params.search == '') this.params.page = 0
      axios(
        "https://api.nfjuara.id/search/nfj_schools/select?" +
          queryStr +
          "defType=edismax&fq=jenjang_s:" +
          jenjang +
          "&qf=school_s&wt=json&rows=1000",
        {
          auth: {
            username: "webapp",
            password: "8B^eduHKUu",
          },
        }
      ).then((response) => {
        var list = response.data.response.docs;
        list.forEach((element) => {
          this.schoolList.push({
            text: element.school_t,
            value: element.school_t,
            npsn: element.npsn_s,
            akreditasi: element.akreditasi_s,
          });
        });
        // console.log(this.schoolList)
        this.$forceUpdate();
      });
    },
    autoCompleteSearch(){
      this.showSuggestion = true
      var objects = this.schoolList
      var queried = []
      for(var i=0; i<objects.length; i++) {
        for(var key in objects[i]) {
          if(objects[i][key].indexOf(this.formUpdateSekolah.namaSekolah)!=-1) {
            queried.push(objects[i]);
          }
        }
      }
      this.querySchool = queried.filter((v,i,a)=>a.findIndex(v2=>(v2.npsn===v.npsn))===i)
      this.$forceUpdate()
    },
    selectingSchool(val){
      this.showSuggestion = false
      this.formUpdateSekolah.namaSekolah = val.text
      this.formUpdateSekolah.npsn = val.npsn
      this.formUpdateSekolah.akreditasi = val.akreditasi
      this.showSuggestion = false
      this.$forceUpdate()
      
    },
    commitSearch(){
      this.showSuggestion = true
      this.querySchool = []
      this.autoCompleteSearch()
    },
    updateDataSekolah(){
      var context = this
        var userId = this.userData.user_id
        var datbod = {
          user_id: userId,
          grade: this.userData.grade,
          province: this.formUpdateSekolah.provinsi,
          school: this.formUpdateSekolah.namaSekolah,
          school_npsn: this.formUpdateSekolah.npsn,
          city: this.formUpdateSekolah.kota,
          school_acreditation: this.formUpdateSekolah.akreditasi,
          school_type: this.formUpdateSekolah.jenisSekolah
        }
        UsmanService.updateUserSchool(datbod, function(response) {
          if (response.success) {
            sessionStorage.setItem('usman_init', JSON.stringify(response.data))
            context.userData = response.data
            context.$forceUpdate()
            $('#modalEditSekolah').modal('hide')
            // context.$store.commit('usman_set_grade', newVal)
            window.alert('Berhasil mengubah data kelas siswa')
          } else {
            window.alert('Gagal mengubah data kelas siswa')
          }
        })
    },
    updateTanggalScope(item, i) {
      var context = this
      if(item.expired_at !== null) {
        if (confirm("Anda yakin akan mengubah tanggal kadaluwarsa scope ini?") == true) {
          console.log(moment(item.expired_at + ' 23:59:59').unix())
          if(moment(item.expired_at + ' 23:59:59').unix() < moment().unix()){
            alert('Tanggal tidak valid')
            context.loadDetailUser()
          } else {
            var token = this.$ls.get('token');
            let uid = JSON.parse(sessionStorage.usman_init)
            var url = process.env.API_BASE_URL + '/account/usman/user/' + uid.user_id + '/scope/' + item.id
      
            this.isLoading = true
            var http = axios.create({
              headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + token
              }
            })

            http.put(url, {'expired_at': moment(item.expired_at + ' 23:59:59').unix() })
            .then(function (response) {
              console.log(response)
              alert('tanggal expired scope berhasil diperbaharui')
              context.loadDetailUser()
            })
            .catch(function (error) {
              console.log(error.message)
              alert('tanggal expired scope gagal diperbaharui')
              context.loadDetailUser()
            })
            .then(function () {
              context.isLoading = false
            })
          }
          
        } else {
          context.loadDetailUser()
        }
      } 
    },
    deleteScope(item, i){
      let text;
      if (confirm("Anda yakin akan menghapus scope dari user ini?") == true) {
          var context = this
          var token = this.$ls.get('token');
          let uid = JSON.parse(sessionStorage.usman_init)
          var url = process.env.API_BASE_URL + '/account/usman/user/' + uid.user_id + '/scope/' + item.id
    
          this.isLoading = true
          var http = axios.create({
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + token
            }
          })

          http.delete(url, {})
          .then(function (response) {
            console.log(response)
            alert('scope berhasil dihapus')
            context.loadDetailUser()
          })
          .catch(function (error) {
            console.log(error.message)
            alert('scope gagal dihapus')
          })
          .then(function () {
            context.isLoading = false
          })
      } else {
        
      }
    },
    checkEmail(){
      var context = this
      var token = this.$ls.get('token');
      var url = process.env.API_BASE_URL + '/account/usman/users'
      var query = null
      var filter = {order: '', orderby: ''}
      context.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })

      var objParams = '{"page": ' + 1 
      if(query !== '') objParams += ', "query": "' + context.newEmail + '"'
      if(filter.order !== '') objParams += ', "order": "DESC"'
      if(filter.orderby !== '') objParams += ', "order_by": "id"'

      objParams += '}'
      http.get(url, {
        params: JSON.parse(objParams)
      }) 
      .then(function(response) {
        context.listEmailSigned = response.data
      })
      .catch(function (error) {
        console.log(error.message)
      })
      .then(function() {
        context.isLoading = false
      })
    },
    updateEmail(){
      const validateEmail = (email) => {
        return email.match(
          /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        );
      };
      if(validateEmail(this.newEmail)){
        if(confirm("apakah anda yakin akan mengubah email untuk user ini menjadi (" + this.newEmail + ")?")){
          this.commitChangeEmail()
        }
      } else{
        alert('email baru tidak valid')
      }
    },
    commitChangeEmail(){
      var context = this
      var token = this.$ls.get('token');
      let uid = JSON.parse(sessionStorage.usman_init)
      var url = process.env.API_BASE_URL + '/account/usman/user/' + uid.user_id + '/update-or-swap-email'

      this.isLoading = true
      var http = axios.create({
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + token
        }
      })
      http.put(url, {'email': this.newEmail })
      .then(function (response) {
        alert('email user berhasil diubah')
        $('#modalEditEmail').modal('hide')
        context.loadDetailUser()
        
      })
      .catch(function (error) {
        console.log(error.message)
        alert('gagal ubah email user')
      })
      .then(function () {
        context.isLoading = false
      })
    }
  },
  mounted: function() {
    let context = this
    context.userData = JSON.parse(sessionStorage.usman_init)
    context.loadDetailData()
    context.loadDetailUser()
    context.loadTicketUser()
    context.loadQuotaConsulUser()
  }
}
</script>



// WEBPACK FOOTER //
// UserManagementDetail.vue?3f050cb0